import React from "react";

const Settings = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 4V8M6 12V20M12 4V14M12 18V20M18 4V5M18 9V20M4 8H8V12H4V8ZM10 14H14V18H10V14ZM16 5H20V9H16V5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

export default Settings;